import { DataGridActiveColumns } from '@virtus/components/DataGrid/models';

export const ReportActivityActiveColumns: DataGridActiveColumns = {
  TimeStamp: true,
  PartitionKey: true,
  RowKey: false,
  CompanyId: false,
  ReportId: false,
  ReportGroup: true,
  ReportName: true,
  BlobName: false,
  ReportType: false,
  StartTime: false,
  EndTime: false,
  BlobContainerName: false,
  ErrorMessage: false,
  IsEmail: false,
  Status: true,
};

export const ReportActivityDetailHeaders = [
  {
    caption: 'TimeStamp',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'TimeStamp',
    dataType: 'datetime',
  },
  {
    caption: 'PartitionKey',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'PartitionKey',
    dataType: 'string',
  },
  {
    caption: 'ReportId',
    allowFiltering: true,
    alignment: 'center',
    dataField: 'ReportId',
    dataType: 'string',
  },
  {
    caption: 'ReportGroup',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'ReportGroup',
    dataType: 'string',
  },
  {
    caption: 'ReportName',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'ReportName',
    dataType: 'string',
  },
  {
    caption: 'Status',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'Status',
    dataType: 'string',
  },
];

export const ReportActivityBaseColumns = {
  TimeStamp: {
    field: 'Report Log TimeStamp',
    filterPlaceholder: 'Search TimeStamp',
    template: 'DateTimeTpl',
    Filter: 'DateFilter',
  },
  PartitionKey: {
    field: 'Report Log PartitionKey',
    filterPlaceholder: 'Search PartitionKey',
  },
  RowKey: {
    field: 'Report Log RowKey',
    filterPlaceholder: 'Search RowKey',
  },
  CompanyId: {
    field: 'Company Id',
    filterPlaceholder: 'Search CompanyId',
  },
  ReportId: {
    field: 'Report Id',
    filterPlaceholder: 'Search Report Id',
  },
  ReportGroup: {
    field: 'Report Group',
    filterPlaceholder: 'Search Report Group',
  },
  ReportName: {
    field: 'Report Name',
    filterPlaceholder: 'Search Report Name',
  },
  BlobName: {
    field: 'Blob Name',
    filterPlaceholder: 'Search Blob Name',
  },
  ReportType: {
    field: 'Report Type',
    filterPlaceholder: 'Search Report Type',
  },
  StartTime: {
    field: 'Start Time',
    filterPlaceholder: 'Search Start Time',
  },
  EndTime: {
    field: 'End Time',
    filterPlaceholder: 'Search End Time',
  },
  BlobContainerName: {
    field: 'Blob Container Name',
    filterPlaceholder: 'Search Blob Container Name',
  },
  ErrorMessage: {
    field: 'Error Message',
    filterPlaceholder: 'Search Error Message',
  },
  IsEmail: {
    field: 'Is Email',
    filterPlaceholder: 'Search Is Email',
  },
  Status: {
    field: 'Status',
    filterPlaceholder: 'Search Status',
  },
};
